import {initScrollableHeader} from '../Utility/ScrollableHeaderUtility';
import {initAllTabs, initTabsWrapper} from './TabsController';
import {Flyout} from '../Contact/Flyout';

export class NavigationController {
  constructor() {
    //remove flyout menus and dark background on clicks
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      document.querySelectorAll('.js-flyoutMenu').forEach(
        (navItem) => {
          if (!target.closest('.mainNavItem__flyoutMenu--active') && !navItem.parentNode?.querySelector('.js-mainNavItem')?.contains(target)) {
            navItem.classList.remove('mainNavItem__flyoutMenu--active');

            if (!target.matches('.js-mainNavItem')) {
              this.removeActiveState();
              document.body.classList.remove('body--menuOpen');
            }
          }
        },
        this,
      );
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        document.querySelectorAll('.js-mainNavItem').forEach(mainNavItem => {
          mainNavItem.classList.remove('mainNavItem__title--active');
        });
        document.querySelectorAll('.js-flyoutMenu').forEach(mainNavItem => {
          mainNavItem.classList.remove('mainNavItem__flyoutMenu--active');
        });
        document.body.classList.remove('body--menuOpen');
      }
    });

    //toggle flyout menu and dark background
    if (document.querySelectorAll('.js-mainNavItem')) {
      document.querySelectorAll('.js-mainNavItem').forEach(menuItem => menuItem.addEventListener('click', () => {
        this.initMenuItem(menuItem);
        this.removeActiveState();
        menuItem?.classList.toggle('mainNavItem__title--active');
        if (menuItem?.parentNode?.querySelector('.js-flyoutMenu')?.classList?.toggle('mainNavItem__flyoutMenu--active')) {
          document.body.classList.add('body--menuOpen');
          if (menuItem?.parentNode?.querySelector('.js-flyoutMenu')?.contains(document.querySelector('.js-productMenu'))) {
            initScrollableHeader(menuItem?.parentNode?.querySelector('.js-scrollableHeader') as HTMLElement);
          }
        } else {
          document.body.classList.remove('body--menuOpen');
        }
      }));
    }

    if (document.querySelector('.js-toggleMobileNav')) {
      document.querySelector('.js-toggleMobileNav')?.addEventListener('click', () => {
        document.querySelector('.header__mainNav')?.classList.toggle('header__mainNav--hidden');
        document.querySelector('.js-toggleMobileNav')?.classList.toggle('actionButton--closeNav');
        document.querySelector('.js-toggleMobileNav')?.querySelector('.js-mobileNavIcon')?.classList.toggle('actionButton--mobileNavIconHidden');
        document.body.classList.toggle('body--menuOpen');
      });
    }

  }

  private initMenuItem(menuItem: Element) {
    let parentElement = menuItem?.parentElement;
    if (!parentElement) {
      return;
    }

    this.unzip(parentElement.querySelector('.js-flyoutMenu'));

    if (parentElement.querySelectorAll('.js-menuMobileBack')) {
      parentElement.querySelectorAll('.js-menuMobileBack').forEach(backButton => backButton.addEventListener('click', () => {
        backButton?.parentNode?.parentNode?.parentNode?.querySelector('.js-flyoutMenu')?.classList?.remove('mainNavItem__flyoutMenu--active');
      }));
    }

    if (parentElement.querySelectorAll('.js-tabContent-markFirstActive') && parentElement.querySelectorAll('.js-tabHeader-markFirstActive')) {
      let tabactive = false;
      parentElement.querySelectorAll('.js-tabContent-markFirstActive').forEach((tab) => {
        if (tab.classList.contains('tabContent__item--active')) {
          tabactive = true;
        }
      });
      if (!tabactive) {
        (parentElement.querySelectorAll('.js-tabContent-markFirstActive'))[0]?.classList.add('tabContent__item--active');
        (parentElement.querySelectorAll('.js-tabHeader-markFirstActive'))[0]?.classList.add('tab__headerListItem--active');
      }
    }
  }

  private removeActiveState() {
    document.querySelectorAll('.js-mainNavItem').forEach(mainNavItem => {
      mainNavItem.classList.remove('mainNavItem__title--active');
    });
  }

  private unzip(element: HTMLElement | null) {
    const flyoutComment = '<!--js-flyoutMenu';
    const contactFlyoutComment = '<!--js-flyoutMenuContact';
    if (!element) {
      return;
    }
    if (!element.innerHTML.includes(flyoutComment) && !element.innerHTML.includes(contactFlyoutComment)) {
      return;
    }
    const contactFlyout = element.innerHTML.includes(contactFlyoutComment);
    element.innerHTML = element.innerHTML
      .replace(contactFlyout ? contactFlyoutComment  : flyoutComment, '')
      .replace('-->', '')
      .replace('--A>', '-->')
      .replace('--A2>', '--A>')
      .replace('--A3>', '--A2>')
      .replace('--A4>', '--A3>')
      .replace('--A5>', '--A4>')
    ;
    initAllTabs(element);
    if (contactFlyout) {
      const flyout = new Flyout();
      flyout.initMobileContactFlyout();
    }
  }
}
